module.exports = __webpack_public_path__ + "img/tutxtlogo.e22233a4.png";